import {Provider} from './provider/Provider';

const SiparislerService = {
    siparisListesi: () => {
        return Provider({
            methodName: 'Module/Siparisler/SiparisListesi',
        });
    },
}

export default SiparislerService;
